export const getSelectedActiveLiveExperience = (instances = [], selectedTargetId = null) => (
  instances.find((instance) => (
    instance.active
    && Array.isArray(instance.participatingDeviceIds)
    && instance.participatingDeviceIds.some(
      (deviceId) => Number(deviceId) === Number(selectedTargetId)
    )
  )) || null
);
